module.exports = __webpack_public_path__ + "img/16-villas.c03eed91.jpg";